import styled, { keyframes } from 'styled-components';

import { theme } from '../../../../global';

export interface IClockContainer {
    $isDark?: boolean;
    $isActive?: boolean;
    $isBlinking?: boolean;
    $isMainClock?: boolean;
}

const blinkingLight = keyframes<IClockContainer>`
    from {
        stroke: ${theme.colors.white};
    }
    
    to {
        stroke: ${theme.colors.disabled_pause};
    }
`;

const blinkingDark = keyframes<IClockContainer>`
    from {
        stroke: ${theme.colors.button_primary};
    }
    
    to {
        stroke: ${theme.colors.disabled_pause};
    }
`;

export const ClockContainer = styled.div<IClockContainer>`
  & path:nth-child(1) {
    stroke: ${({ $isDark }) => ($isDark ? theme.colors.button_primary : theme.colors.white)};
    stroke-width: 4px !important;
    stroke-linecap: round;
    stroke-dasharray: 1 22;
  }

  & path:nth-child(2) {
    stroke: ${({ $isDark }) => ($isDark ? theme.colors.button_primary : theme.colors.white)};
    stroke-width: 8px !important;

    animation: 0.7s
      ${({ $isBlinking, $isDark }) =>
        $isBlinking && $isDark ? blinkingDark : $isBlinking ? blinkingLight : ''}
      infinite;
  }

  & path:nth-child(2):after {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: ${({ $isDark }) =>
        $isDark ? theme.colors.button_primary : theme.colors.white};
  }
`;

export const ClockTime = styled.p<IClockContainer>`
  font-size: ${({ $isMainClock }) => ($isMainClock ? '120px' : '64px')};
  line-height: ${({ $isMainClock }) => ($isMainClock ? '146px' : '78px')};

  font-weight: ${({ $isMainClock }) => $isMainClock && '500'};
  margin-top: ${({ $isMainClock }) => $isMainClock && '200px'};
  color: ${({ $isDark }) => ($isDark ? theme.colors.error : theme.colors.white)};

  @media (max-width: 1358px) {
    margin-top: ${({ $isMainClock }) => $isMainClock && '0'};
    font-size: ${({ $isMainClock }) => $isMainClock && '40px'};
    line-height: ${({ $isMainClock }) => $isMainClock && '44px'};

    position: ${({ $isMainClock }) => $isMainClock && 'relative'};
    top: ${({ $isMainClock }) => $isMainClock && '25px'};
    right: ${({ $isMainClock }) => $isMainClock && '50px'};
  }
`;

export const TimeContainer = styled.div<IClockContainer>`
  @media (max-width: 1358px) {
    font-weight: 500;
    font-size: 40px;
    display: ${({ $isActive, $isDark }) => ($isActive && !$isDark ? 'block' : 'none')};
  }
`;

export const LittleClockContainer = styled.div<IClockContainer>`
  display: none;
  font-weight: 500;
  font-size: 40px;
  line-height: 44px;

  @media (max-width: 1358px) {
    display: ${({ $isActive }) => ($isActive ? 'none' : 'block')};
  }
`;
